<ngx-ui-loader></ngx-ui-loader>
<div id="distribution" class="page-layout simple tabbed">
  <distribution-header [complexId]="complexId" (searchString)="sendSearchFilter($event)"></distribution-header>
  <div class="page-wrapper">
    <complex-selector (complexConn)="sendComplexId($event)"></complex-selector>
    <distribution-table [complexId]="complexId" [searchString]="search"></distribution-table>
  </div>
</div>
